export const homeObjTwo = {
    id: 'discover',
    lightBg: true,
    lightText: false,
    lightTextDesc: false,
    topLine: 'Marzo 2026',
    headline: 'Santa Cena',
    description: '1 de Marzo, 2026 | 10 AM',
    buttonLabel: 'Información',
    imgStart: false,
    img: "https://github.com/jcrommar/dallas-gerizim/blob/main/public/images/santa_cena_feb_2026.jpg?raw=true",
    alt: 'Ministerio',
    dark: false,
    primary: false,
    darkText: true
};
